(angular => {
  "use strict";

  angular.module("App").factory("LoginService", [
    "$http",
    "$location",
    "API",
    "jwtHelper",
    "AuthService",
    LoginService
  ]);

  function LoginService($http, $location, API, jwtHelper, authService) {

    const logout = () => {
      authService.removeToken();
      $location.path("/");
    };

    const doLogin = (cpf) => {
      return $http.post(`${API}/auth/login`, { cpf }).then(result => {
        return result.data;
      });
    };

    const guestLogin = (user) => {
      return $http.post(`${API}/auth/sender-login`, { user }).then(result => {
        return result.data;
      });
    };

    const recover = (email) => {
      return $http.post(`${API}/auth/recover`, { email }).then(res => res.data);
    };


    const doReset = (data) => {
      return $http.post(`${API}/auth/reset-password`, data);
    };


    const changeEvent = (eventId) => {
      return $http.post(`${API}/auth/change-event`, { eventId });
    };

    const saveEventGuest = (eventGuest) => {
      return $http.post(`${API}/publico/eventGuest`, eventGuest)
        .then(res => res.data);
    };

    const publicResgister = (publicResgister) => {
      return $http.post(`${API}/guest/publicResgister`, publicResgister)
        .then(res => res.data);
    };




    return {
      logout,
      doLogin,
      guestLogin,
      doReset,
      changeEvent,
      recover,
      saveEventGuest,
      publicResgister
    };

  }

})(angular);
